const differentiators = [
  {
    icon: 'ri-award-line',
    title: 'Licensed Georgia General Contractor',
    desc: 'Fully licensed and insured in the state of Georgia. Every project meets or exceeds local building codes and inspection standards.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Deep Henry County Expertise',
    desc: 'We know the local permitting process, building departments, and inspection requirements — which means fewer delays and faster approvals.',
  },
  {
    icon: 'ri-team-line',
    title: 'Single Point of Accountability',
    desc: 'One team manages every trade from start to finish. No finger-pointing, no miscommunication — just clear ownership and results.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Structured Timelines, Delivered',
    desc: 'We build detailed project schedules and hold to them. Our clients open on time because we plan for every contingency upfront.',
  },
  {
    icon: 'ri-message-3-line',
    title: 'Transparent Communication',
    desc: 'Regular updates, documented progress, and direct access to your project manager throughout every phase of construction.',
  },
  {
    icon: 'ri-store-3-line',
    title: 'Franchise & Multi-Tenant Experience',
    desc: 'We understand brand standards, corporate requirements, and the complexity of multi-tenant builds — and we deliver to spec every time.',
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/cb655d9a1c2546cb9e8eb0630eae2d9d.jpg"
                alt="Fletcher & Cooley Project Management"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-amber-700 text-white rounded-2xl p-6 max-w-[200px]">
              <p
                className="text-3xl font-bold"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                500+
              </p>
              <p className="text-amber-200 text-xs mt-1 leading-snug">
                Commercial projects completed across Henry County &amp; Metro Atlanta
              </p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-amber-600" />
              <span className="text-amber-700 text-xs font-semibold tracking-[0.2em] uppercase">
                Why Choose Us
              </span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              The Premium Choice for
              <br />
              <span className="text-amber-700">Commercial Construction</span>
            </h2>
            <p className="text-stone-500 text-base leading-relaxed mb-10">
              Fletcher &amp; Cooley isn&apos;t the cheapest option — we&apos;re the right one. Our clients choose us because they need a contractor who shows up, communicates clearly, and delivers a finished space that works.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {differentiators.map((d) => (
                <div key={d.title} className="flex gap-4">
                  <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-amber-100 rounded-xl mt-0.5">
                    <i className={`${d.icon} text-amber-700 text-lg`} />
                  </span>
                  <div>
                    <h3 className="font-bold text-stone-900 text-sm mb-1">{d.title}</h3>
                    <p className="text-stone-500 text-xs leading-relaxed">{d.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
